import Loader from "react-loader-spinner";
import { faBoxOpen, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState, Fragment } from "react";
import { Alert, Button, Form, FormGroup, Modal } from "react-bootstrap";
import { addOrUpdateProduct, getAllProductHolders, getAllProductTypesNew, getLastCode, getProductGroups4Select } from "../../store/api/GetAllProduct";
import { CheckLg, DashCircle, ExclamationTriangle } from "react-bootstrap-icons";
import { translateError } from "../../store/api/CommonFunctions";

const ModalAddNewProductForSelect = (props) => {
    const submitData = useRef({});
    const { popData, setPopData } = props;
    const { show, productGroupingType, setProductData, defaultStorages, dontSetStg } = popData;
    const pgType = Number(productGroupingType);
    const [submitError, setSubmitError] = useState(null);
    const [lastCode, setCode] = useState(null);
    const [typeList, setTypeList] = useState([]);
    const [holderList, setHolderList] = useState([]);
    const [productGroups, setProductGroups] = useState([]);
    function close() {
        setPopData({
            show: false
        })
        setSubmitError(null);
    }
    function setSubmitData(e) {
        const name = e.target.name;
        const value = e.target.value;
        submitData.current[name] = value;
        if (name === "GroupID") {
            submitData.current.GroupID = null;
            if (value && value !== "") {
                const list = e.target.getAttribute('list');
                const options = document.querySelectorAll('#' + list + ' option');

                for (let i = 0; i < options.length; i++) {
                    var option = options[i];
                    if (option.innerText.replaceAll(" ", "") === value.replaceAll(" ", "")) {
                        submitData.current.GroupID = option.getAttribute('data-value');
                        break;
                    }
                }
            }
        }
        if (name === "TypeID" && Array.isArray(typeList)) {
            submitData.current.Name = typeList.find(t => Number(t.ID) === Number(value))?.Name;
        }
    }
    function onSubmitData() {
        setSubmitError(null);
        if (pgType !== 1 && (submitData.current.HolderID ?? "") === "") {
            setSubmitError("مارک کالا انتخاب نشده است");
            return;
        }
        if ((submitData.current.Name ?? "") === "") {
            setSubmitError("نام/نوع کالا وارد نشده است");
            return;
        }
        if ((submitData.current.Model ?? "") === "") {
            setSubmitError("مدل کالا وارد نشده است");
            return;
        }
        if (pgType === 1 && (submitData.current.GroupID ?? "") === "") {
            setSubmitError("گروه کالا انتخاب نشده است");
            return;
        }
        submitData.current.UsedInServices = true;
        submitData.current.UsedInStorage = true;
        if (!submitData.current.KalaCode) {
            submitData.current.KalaCode = lastCode;
        }
        if (pgType === 1) {
            submitData.current.ProductGroups = [{ GroupID: submitData.current.GroupID }];
        }
        const onSuccess = (res) => {
            if (res.Data) {
                var data = {};
                data.ProductID = res.Data.ID;
                data.ProductName = res.Data.Name;
                data.ProductModel = res.Data.Model;
                data.ProductHardCode = res.Data.Hard_Code;
                data.UnitPrice = 0;
                data.SuggestedCount = 1;
                if (!dontSetStg) {
                    data.StorageID = defaultStorages.SrcStorageID;
                    data.StorageName = defaultStorages.SrcStorageName;
                }
                if (setProductData) {
                    setProductData(data);
                    setPopData({
                        show: false
                    })
                }
            }
            else if (res.Error) {
                setSubmitError(translateError(res.Error));
            }
        }
        addOrUpdateProduct(submitData.current, onSuccess)
    }
    useEffect(() => {
        if (show) {
            submitData.current = {};
            getLastCode(setCode);
            getProductGroups4Select("", setProductGroups);
            getAllProductHolders(1, setHolderList);
            getAllProductTypesNew(setTypeList);

        }
    }, [show])
    return (
        <Modal size="sm" show={show} onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faBoxOpen} size="lg" />&nbsp;ثبت و انتخاب کالا/محصول
                </span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                {submitError &&
                    <Alert variant="danger">
                        <ExclamationTriangle size={18} />&nbsp;
                        {submitError}
                    </Alert>
                }
                <FormGroup className="mt-0">
                    <label>کد کالا: </label>
                    {isNaN(lastCode) &&
                        <div className="form-control">
                            <Loader width={20} height={20} type="BallTriangle" color="#bb1370" />
                        </div>
                    }
                    {!isNaN(lastCode) &&
                        <Form.Control type="number" name="KalaCode" onChange={setSubmitData} value={lastCode ?? ""}/>
                    }
                </FormGroup>
                {pgType !== 1 &&
                    <Fragment>
                        <FormGroup >
                            <label>مارک کالا: </label><span style={{ color: "red" }}>*</span>
                            {holderList === "PENDING" &&
                                <div className="form-control">
                                    <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                </div>
                            }
                            {holderList && Array.isArray(holderList) &&
                                <select name="HolderID" className="form-control" onChange={setSubmitData}
                                >
                                    <option value="">انتخاب کنید</option>
                                    {holderList.map((item, i) => <option key={i} value={item.ID}>{item.HolderName}</option>)}
                                </select>
                            }
                        </FormGroup>

                        <FormGroup>
                            <label>نوع کالا: </label><span style={{ color: "red" }}>*</span>
                            {typeList === "PENDING" &&
                                <div className="form-control">
                                    <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                </div>
                            }
                            {typeList && Array.isArray(typeList) &&
                                <select name="TypeID" className="form-control" onChange={setSubmitData}>
                                    <option value="">انتخاب کنید</option>
                                    {typeList.map((item, i) => <option key={i} value={item.ID}>{item.Name}</option>)}
                                </select>
                            }
                        </FormGroup>
                    </Fragment>
                }
                {pgType === 1 &&
                    <FormGroup>
                        <label>نام کالا: </label><span style={{ color: "red" }}>*</span>
                        <Form.Control name="Name" onChange={setSubmitData} />
                    </FormGroup>
                }
                <FormGroup>
                    <label>مدل کالا: </label><span style={{ color: "red" }}>*</span>
                    <Form.Control name="Model" onChange={setSubmitData} />
                </FormGroup>
                {pgType === 1 &&
                    <FormGroup>
                        <label>گروه کالا: </label>
                        <Form.Control list="productGroups" autoComplete='on' name="GroupID" onChange={setSubmitData} className="hideCalendarPicker" />
                        <datalist id="productGroups">
                            {productGroups && Array.isArray(productGroups) &&
                                productGroups.map((item, i) => <option data-value={item.GroupID} key={i} style={{ fontFamily: "Vazir" }}>{item.MainGroupName + "-" + item.GroupName}</option>)}
                        </datalist>
                    </FormGroup>
                }
                <FormGroup>
                    <label>محصول یا قطعه؟</label>
                    <select onChange={setSubmitData} name="ProductOrPart" className="form-control">
                        <option value={false}>محصول</option>
                        <option value={true}>قطعه</option>
                    </select>
                </FormGroup>
                <div className="mt-2">
                    <Button variant="success" className="group-Btn" onClick={onSubmitData}><CheckLg />&nbsp;ثبت کالا</Button>
                    <Button variant="danger" className="group-Btn" onClick={close}><DashCircle size={17} />&nbsp;  انصراف</Button>

                </div>
            </Modal.Body>
        </Modal>
    )
}
export default ModalAddNewProductForSelect;